var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "card_bg",
    width: 24,
    height: 16,
    rx: 2,
    fill: "#2A2A6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.17 8.81C15.17 8.07882 14.5666 7.76071 14.0851 7.50694C13.7633 7.33727 13.496 7.19636 13.5 6.98C13.5 6.81 13.66 6.63 14 6.59C14.4041 6.55185 14.8111 6.62083 15.18 6.79L15.39 5.79C15.0345 5.65895 14.6589 5.59126 14.28 5.59C13.09 5.59 12.28 6.22 12.28 7.12C12.28 7.77349 12.8682 8.11326 13.3166 8.37228L13.33 8.38C13.78 8.64 13.95 8.75 13.95 8.95C13.95 9.15 13.58 9.4 13.24 9.4C12.8103 9.41907 12.3829 9.32602 12 9.13L11.78 10.13C12.2065 10.2849 12.6563 10.366 13.11 10.37C14.37 10.37 15.19 9.75 15.19 8.79L15.17 8.81ZM11.93 5.69L10.93 10.32H9.74001L10.74 5.69H11.93ZM16.93 8.69L17.56 6.95L18 8.68L16.93 8.69ZM19.37 10.33H18.27L18.1 9.64H16.57L16.32 10.33H15.06L16.86 6.04C16.9452 5.83366 17.1468 5.69932 17.37 5.7H18.37L19.37 10.33ZM8.28001 10.32L10.22 5.69H9.00001L7.66001 8.84L7.15001 6.17C7.11048 5.89607 6.87676 5.6921 6.60001 5.69H4.60001V5.83C4.98685 5.91736 5.36257 6.04819 5.72001 6.22C5.87554 6.3018 5.98042 6.45537 6.00001 6.63L7.00001 10.32H8.28001Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaColor);
export default __webpack_public_path__ + "static/media/visa-color.44139e60.svg";
export { ForwardRef as ReactComponent };